import React from 'react';

const ManifestResultModal = ({ isOpen, onClose, result }) => {
    if (!isOpen || !result) return null;

    const { s3_uri, items } = result || {};

    // Attempt to build an HTTPS URL for convenience if s3_uri is in form s3://bucket/key
    let httpsUrl = '';
    if (typeof s3_uri === 'string' && s3_uri.startsWith('s3://')) {
        try {
            const withoutScheme = s3_uri.replace('s3://', '');
            const firstSlash = withoutScheme.indexOf('/');
            const bucket = firstSlash === -1 ? withoutScheme : withoutScheme.slice(0, firstSlash);
            const key = firstSlash === -1 ? '' : withoutScheme.slice(firstSlash + 1);
            if (bucket && key) {
                httpsUrl = `https://${bucket}.s3.amazonaws.com/${encodeURI(key)}`;
            }
        } catch {}
    }

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(s3_uri || '');
        } catch {}
    };

    return (
        <div className="fixed inset-0 z-[9999] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="relative w-full max-w-lg bg-gradient-to-br from-[#0a1628] to-[#1a2448] rounded-xl border border-[#4cc3e9]/30 p-6">
                <h2 className="text-xl font-semibold text-white mb-4">Manifest Generated</h2>

                <div className="space-y-3">
                    <div className="text-sm text-white/80">The manifest file has been uploaded to S3.</div>

                    <div className="p-3 rounded-lg bg-white/5 border border-white/10">
                        <div className="text-xs text-white/60 mb-1">S3 URI</div>
                        <div className="flex items-start gap-2 break-all">
                            <code className="text-white text-sm flex-1">{s3_uri}</code>
                            <button onClick={handleCopy} className="px-2 py-1 text-xs rounded bg-white/10 border border-white/20 text-white hover:bg-white/20">Copy</button>
                        </div>
                    </div>

                    {typeof items === 'number' && (
                        <div className="p-3 rounded-lg bg-white/5 border border-white/10">
                            <div className="text-xs text-white/60 mb-1">Items</div>
                            <div className="text-white text-sm">{items}</div>
                        </div>
                    )}

                    {httpsUrl && (
                        <a
                            href={httpsUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-600 text-white text-sm"
                        >
                            Open in browser
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 3h7m0 0v7m0-7L10 14" />
                            </svg>
                        </a>
                    )}
                </div>

                <div className="flex items-center justify-end gap-3 mt-6">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-white/10 border border-white/20 text-white hover:bg-white/20 transition-colors"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ManifestResultModal;

